import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { ESTADO_CLIENTE } from 'Constants'
import { interfaces } from 'service/interfaces'

import { Step1 } from './Content'

const Create = (props) => {
  const { data, open, handleClose, render, setRender } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const BLOQUEADO = ESTADO_CLIENTE.find((e) => e.label === 'BLOQUEADO')?.value
  const INHABILITADO = ESTADO_CLIENTE.find((e) => e.label === 'INHABILITADO')?.value

  const isClientBlockedOrDisabled = (estado) => {
    const value = Number(estado)
    return value === Number(BLOQUEADO) || value === Number(INHABILITADO)
  }

  const getClientStatusMessage = (estado) => {
    const value = Number(estado)
    if (value === Number(BLOQUEADO)) return 'El cliente está bloqueado.'
    if (value === Number(INHABILITADO)) return 'El cliente está inhabilitado.'
    return 'El cliente no está habilitado.'
  }

  const [isLoading, setIsLoading] = useState(false)

  const [info, setInfo] = useState({
    empresa: 1,
    formato_venta: 1,
    search: '',
    cuit: '',
    tipo_responsable: null,
    nombre: '',
    cliente_id: null,
    estado: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return (
      <InputsWithoutValidate
        fields={Step1(info, handleSubmitCode, handleChange, isLoading, data)}
        spacing={2}
      />
    )
  }

  async function handleSubmitCode(info) {
    setIsLoading(true)
    await interfaces.salesOrders
      .searchClients(info)
      .then((res) => {
        const clientData = res.data[0]

        if (isClientBlockedOrDisabled(clientData?.estado)) {
          createDismissableSnackbar(getClientStatusMessage(clientData?.estado), {
            variant: 'error',
          })

          setInfo((prev) => ({
            ...prev,
            data: null,
            cuit: '',
            tipo_responsable: null,
            nombre: '',
            cliente_id: null,
            estado: clientData?.estado ?? null,
          }))
          return
        }
        setInfo({
          ...info,
          data: clientData,
          cuit: clientData.cuit,
          tipo_responsable: clientData.tipo_responsable,
          nombre: clientData.nombre,
          cliente_id: clientData.id,
          estado: clientData.estado,
        })
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })

    setIsLoading(false)
  }

  const create = async () => {
    if (!info.empresa || !info.search) {
      createDismissableSnackbar("Los campos 'Origen' y 'CUIT/CUIL/DNI' son obligatorios", {
        variant: 'error',
      })
      return
    }

    if (isClientBlockedOrDisabled(info.estado)) {
      createDismissableSnackbar(getClientStatusMessage(info.estado), {
        variant: 'error',
      })
      return
    }
    const values = {
      empresa: info.empresa,
      cliente_id: info.cliente_id,
      formato_venta: info.formato_venta,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .create(values)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleClose()
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    handleClose()
    setIsLoading(false)
  }

  function disabledSubmit() {
    return !info.cuit || isClientBlockedOrDisabled(info.estado)
  }

  return (
    <DialogComponent
      title="Nuevo pedido"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading ? true : disabledSubmit()}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={create}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default Create
